import { Component, Inject, Input, OnInit } from "@angular/core";

import { userPermissions } from "@src/constants/userPermissions";

@Component({
  selector: "user-management-menu-drop-down",
  template: require('./user-management-menu-drop-down.component.html'),
})
export class UserManagementMenuDropDownComponent implements OnInit {
  @Input() public isAdmin: any;

  public canGrantAndRevokePrivileges: any;
  public linkUrl: any;
  public canManageCmss: any;
  public canManageVault: boolean = false;
  public canManageTagTypes: any;
  public canEditAdminConfiguration: boolean;

  constructor(
    @Inject("authorizationService") private authorizationService: any,
    @Inject("$state") private $state: any
  ) { }

  public async ngOnInit() {
    const isAuthorized = async (action: any) =>
      await this.authorizationService.isAuthorizedToPerformAction(action);
    const canGrantAndRevokePrivileges = this.isAuthOnly()
      ? true
      : await isAuthorized(userPermissions.GrantAndRevokePrivileges);
    const canManageUsers = this.isAuthOnly()
      ? true
      : await isAuthorized(userPermissions.AddUser);
    const canManageCmss = await isAuthorized(
      userPermissions.ConfigureTWCMSProvider
    );
    const canManageTagTypes = await isAuthorized(
      userPermissions.ManageTagTypes
    );
    const canEditAdminConfiguration = await isAuthorized(
      userPermissions.EditAdminConfiguration
    );
    const isAdmin = this.isAuthOnly() ? true : await this.authorizationService.isAdmin();

    setTimeout(() => {
      this.isAdmin = isAdmin;
      this.canGrantAndRevokePrivileges = canGrantAndRevokePrivileges;
      this.linkUrl = canManageUsers
        ? "usersManagement.users"
        : "rolesManagement";
      this.canManageCmss = canManageCmss;
      this.canManageTagTypes = canManageTagTypes;
      this.canManageVault = true;
      this.canEditAdminConfiguration = canEditAdminConfiguration;
    }, 50);
  }

  public navigate(event: any, sref: any) {
    event.preventDefault();
    this.$state.go(sref);
  }

  public isAuthOnly() {
    return localStorage.getItem("AuthOnly") == "true";
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/side-menu/user-management-menu-drop-down/user-management-menu-drop-down.component.ts